import React, { useEffect } from "react";
import moment from 'moment-timezone';
import defaultImage from "assets/img/image_placeholder.jpg";
import ImageUpload from 'components/CustomUpload/ImageUpload';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import {  loadZoom, updateExistingClass, loadServices, updateExistingService, uploadDuplicateService, uploadNewClasses, uploadNewServiceWithClasses, uploadNewService } from 'store/actions/schedulingActions';
import CustomSelect from './CustomSelect';
import { useForm, Controller } from "react-hook-form";
import { DevTool } from "react-hook-form-devtools";
import Select from 'react-select'
import * as yup from 'yup';
import FormField from 'components/FormField'
import FormGroup from 'components/Form/FormGroup'
import CustomReactSelect from 'components/Store/CustomReactSelect'
import Spinner from 'react-bootstrap/Spinner'
import './ServiceEditor.scss';
import PlacesSearch from "components/PlacesSearch";
// import {NavLink} from 'util/router'
// Switch, Route, Router,
import {NavLink,  useRouteMatch, useHistory, useRouter } from "util/router.js";
import {ImageAndUpload} from 'components/Form/FormImageUploader'
import {symbolFromCurrency} from 'components/PartnerInfoForm'

const DATE_FORMAT = 'ddd MMM D, YYYY';
const TIME_FORMAT = 'h:mm A';
const CREATE_NEW = 'Create New...';

function ClassEditor(props) {

    const dispatch = useDispatch();
    const router = useRouter();
    const [timezone, setTimezone] = React.useState(moment.tz.zone(moment.tz.guess()).abbr((new Date()).getTimezoneOffset()))
    

    const {
        newClass, // boolean -- adding a new class with blank template
        editClass,  // object: classObject -- editing an existing class
        newService,
        editService, // object: serviceObject -- editing an existing service that applies changes to all future classes of this type
        challengeid// boolean -- if this is adding a challenge, this is the id for the challenge
    } = props;

    const [openForm, setOpenForm] = React.useState(true)    
    const existingServiceObject = editClass || editService || ((typeof newService === 'object' && newService !== null) ? newService : null);
    const [showAdvanced, setShowAdvanced] = React.useState(false)

    const isLoading = useSelector(state => state.scheduling.inProgress)
    const zoomConnected = useSelector(state => state.scheduling.zoomConnected)
    const currentUser = useSelector(state => state.user.userData)
    const currency = useSelector(state => state.user.userData?.instructorProfile?.currency ?? "USD")
    const currencySymbol = symbolFromCurrency(currency)
    const existingServices = useSelector(state => state.scheduling.services.map(val => {
        return { value: val, label: val.name }
    }))
    const connected = useSelector(state => state.scheduling.connectedAccounts.map(val => {
        return val.instructor
    }))
    const connectedAccounts = connected.concat(currentUser).map(val => {
        return {
            ...val,
            id: val.id ?? val.platformID ?? val.userID

        }
    })

    const connectedAccountOptions = connectedAccounts.map(val => {
        return {
            label: (val.firstName + ` ${val.lastName ? val.lastName : ""}`),
            value: val.id ?? val.platformID ?? val.userID
        }
    }).sort((a,b) => {
        if(a.label < b.label) { return -1; }
        if(a.label > b.label) { return 1; }
        return 0;
    })

    console.log("Connected accoutn options: ", connectedAccountOptions)

    useEffect(() => {
        if (currentUser.platformID) {
            dispatch(loadZoom());
            // dispatch(loadServices());
        }
    }, [currentUser])


    const { watch, register, control, handleSubmit, setValue, getValues, formState, reset, triggerValidation, errors } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            existing_service_type: yup.string(),
            service: yup.object({
                experience_type: yup.string().required(),
                // location_type: yup.string(),
                name: yup.string().required(),
                description: yup.string().required(),
                workout_types: yup.array().of(yup.string()),
                body_focus: yup.string(),
                intensity: yup.string(),
                equipment_required: yup.array().of(yup.string()),
                purchase_type: yup.string().required(),
                price: yup.number().when('purchase_type', {
                    is: val => val === 'Paid',
                    then: yup.number().positive()
                }),
                minimum_price: yup.number(),
                max_capacity: yup.number(),
                images: yup.array(),
                preview_url: yup.string(),
                location_name: yup.string(),
                instagram_handle: yup.string(),
                zoom_link: yup.string(),
                youtube_link: yup.string(),
                other_link: yup.string(),
                platformID: yup.string(),
                location: yup.object() // physical address location
                // file1: yup.object()
            }),
            meet_time: yup.string(), //Weekly || Specific Date
            start_date: (newClass || editClass) ? yup.string().required() : yup.string(),
            end_date: yup.string(),
            days_of_the_week: (newClass || editClass) ? yup.array().min(1) : yup.array(),
            start_time: (newClass || editClass) ? yup.string().required() : yup.string(),
            duration: (newClass || editClass) ? yup.number().positive().required() : yup.number(),
            // end_time: yup.string(),
            hosted_by: yup.array().min(1, 'Please choose who is teaching').required("Please choose who is teaching")
            // duration: yup.number().required(),
            
        }),
        defaultValues: {
            // existing_service_type: {value: (existingServiceObject?.name ?? CREATE_NEW), label: (existingServiceObject?.name ?? CREATE_NEW)},
            existing_service_type: existingServiceObject?.name ?? CREATE_NEW,
            service: existingServiceObject ?? initialNewServiceValues,
            hosted_by: (existingServiceObject?.host_ids?.length > 0) ? existingServiceObject.host_ids : [currentUser.platformID],
            // hosted_by: (existingServiceObject?.host_ids?.length > 0) ? existingServiceObject.host_ids[0] : currentUser.platformID,
            meet_time: 'Specific Date',
            start_date: (editClass?.start_time) ? moment(editClass.start_time * 1000).format(DATE_FORMAT) : moment().add(1,'day').format(DATE_FORMAT),
            end_date: moment().add(1,'M').format(DATE_FORMAT),
            // days_of_the_week: [{value:moment().format('dddd'), label:moment().format('dddd')}],
            days_of_the_week: [(editClass?.start_time) ? moment(editClass.start_time * 1000).format("dddd") : moment().format('dddd')],
            start_time: (editClass?.start_time) ? moment(editClass.start_time * 1000).format(TIME_FORMAT) : "9:00 AM",
            duration: editClass?.duration ?? 60
            // end_time: (editClass?.start_time && editClass?.duration) ? moment(editClass.start_time * 1000).add(editClass.duration,'minutes').format(TIME_FORMAT) : "10:00 AM"
          }
    });

    useEffect(() => {
        // register({name: "hostData"})
        // register({name: 'hosted_by'})
        register({name: "service.experience_type" })
        // register({name: "service.name" })
        // register({name: "service.description" })
        register({name: "service.workout_types" })
        register({name: "service.file1"})
        register({name: "service.body_focus" })
        register({name: "service.intensity" })
        register({name: "service.equipment_required" })
        register({name: "service.purchase_type" })
        // register({name: "service.price" })
        // register({name: "service.minimum_price" })
        // register({name: "service.max_capacity" })
        register({name: "service.images" })
        register({name: "service.preview_url" })
        register({name: "service.location_name" })
        register({name: "service.location"})
        // register({name: "service.instagram_handle" })
        // register({name: "service.zoom_link" })
        // register({name: "service.youtube_link" })
        // register({name: "service.other_link" })
        register({name: "service.platformID" })

        register({name: "existing_service_type"})
        register({name: "meet_time"})
        register({name: "start_date"})
        register({name: "end_date"})
        register({name: "days_of_the_week"})
        register({name: "start_time"})
        // register({name: "duration"})
        // register({name: "end_time"})

        // register({name: 'existing_service_type'})
        // register({name: 'service.experience_type' })
        // register({name: "service.workout_types"})
        // register({name: "service.body_focus"})
        // register({name: "service.intensity"})
        // register({name: "service.equipment_required"})
        // register({name: "service.location_name"})
        // register({name: "service.purchase_type"})
        // register({name: "meet_time"})
        // register({name: "days_of_the_week"})
        // register({name: "start_date"})
        // register({name: "end_date"})
        // register({name: "start_time"})
        // register({name: "end_time"})
    }, [register])

    useEffect(() => {
        if (existingServiceObject) {
            setShowAdvanced(true)
        }
    }, [existingServiceObject])


    var formTitle = ""
    // const { 
    //     newClass, // boolean -- adding a new class with blank template
    //     editClass,  // object: classObject -- editing an existing class
    //     editService // object: serviceObject -- editing an existing service that applies changes to all future classes of this type
    // } = props;
    if (newClass) {
        formTitle = "List a new experience"
    } else if (editClass) {
        formTitle = `Editing "${(editClass.name || editClass.class_name) ?? ""}"`
    } else if (editService) {
        formTitle = `Editing "${(editService.name || editService.class_name) ?? ""}"`
    } else if (newService) {
        formTitle = "Create a new template"
    } else {
        formTitle = "ERROR"
    }

    const htmlPlainText = (html) => {

        console.log("html", html)
        html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
        html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
        html = html.replace(/<\/div>/ig, '\n');
        html = html.replace(/<\/li>/ig, '\n');
        html = html.replace(/<li>/ig, '  *  ');
        html = html.replace(/<\/ul>/ig, '\n');
        html = html.replace(/<\/p>/ig, '\n');
        html = html.replace(/<br\s*[\/]?>/gi, "\n");
        html = html.replace(/<[^>]+>/ig, '');

        return html
    }
    // if (errors) {
    //     console.log("Got erros submittig: ", errors)
    // }
    const findHostDataForHostIds = () => {
        // const hosted_by = (existingServiceObject?.host_ids?.length > 0) ? existingServiceObject.host_ids[0] : currentUser.platformID;
        // const theConnected = connectedAccounts.find(acct => acct.id === hosted_by)
        // // setValue('hostData', theConnected)
        
        // // setHostData(hosted_by)
        // return theConnected

        const hostIds = (existingServiceObject?.host_ids?.length > 0) ? existingServiceObject.host_ids : [currentUser.platformID];
        const hostDataArray = hostIds.map(hostId => {
            var connectedHost = connectedAccounts.find(acct => acct.id === hostId)
            return connectedHost
        })
        // const theConnected = connectedAccounts.find(acct => acct.id === hosted_by)

        return hostDataArray
    }

    const [hostData, setHostData] = React.useState(findHostDataForHostIds())
    const onSubmit = (form_data) => {
        form_data.hostData = hostData
        console.log("Handle submit")
        console.log("Saving form data: ", form_data)
        

        // form_data.service.location_type = "live" // TODO update this to use live or inperson ondemand
        // if (form_data.description) {
        //     var description_copy = (' ' + form_data.description).slice(1);
        //     form_data.descriptionHTML = description_copy
        //     form_data.description = htmlPlainText(form_data)
        // }
        // return
        form_data.service.price = Number(form_data.service.price || 0);
        form_data.service.minimum_price = Number(form_data.service.minimum_price || 0);
        form_data.service.max_capacity = Number(form_data.service.max_capacity || 9999);
        if (form_data.service.purchase_type === "Free") {
            form_data.service.price = Number(0);
            form_data.service.minimum_price = Number(0);
        }

        const {
            location_name,
            instagram_handle,
            zoom_link,
            youtube_link,
            other_link } = form_data.service;

        var content_link = ""
        switch ((location_name ?? "").toLowerCase().replace(/\s/g, '')) {
        case "instagram":
            content_link = `https://instagram.com/${instagram_handle}`;
            form_data.service.location_type = "live"
            break
        case "zoom":
            content_link = zoom_link;
            form_data.service.location_type = "live"
            break
        case "youtube":
            content_link = youtube_link;
            form_data.service.location_type = "live"
            break
        case "other":
            content_link = other_link;
            form_data.service.location_type = "live"
            break
        case "inperson":
            content_link = form_data?.service?.location?.contentLink ?? form_data?.service?.location?.address ?? 'Google maps'
            form_data.service.location_type = "inperson"
            break
        }

        if (challengeid) { // this might break something JARCH
            // form_data.service.location_type = "challenge"
            // economically prevent person from purchasing
            form_data.service.price = 1000
            form_data.service.minimum_price = 1000
            form_data.service.max_capacity = 99999
            form_data.service.purchase_type = "Paid"

            form_data.service.challengeId = challengeid
        }

        if (form_data.service.experience_type.toLowerCase() === "appointment") {
            form_data.service.location_type = "private"
        }
        // if (location_name === "Instagram") {
        //     content_link = `https://instagram.com/${instagram_handle}`;
        // } else if (location_name?.toLowerCase() === "zoom") {
        //     content_link = zoom_link;
        // } else if (location_name === "Youtube") {
        //     content_link = youtube_link;
        // } else if (location_name === "Other") {
        //     content_link = other_link;
        // } else if (location_name === "In person") {
        //     content_link = "some google maps link... "
        // }
        form_data.service.content_link = content_link;
        form_data.service.reserve_link = content_link;

        if (form_data.service.description) {
            var description_copy = (' ' + form_data.service.description).slice(1);
            form_data.service.descriptionHTML = description_copy
            form_data.service.description = htmlPlainText(form_data.service.description)
        }

        const new_time_objects = buildModelsFrom(form_data);

        if (location_name === 'zoom' && zoomConnected && new_time_objects.length > 75) {
            window.alert("Please try adding less than 75 Zoom classes at one time. Zoom has a limit on the amount of Zoom meetings that Sutra can create on your behalf. Please contact Sutra support if you have any questions :)")
            return
        }

        // console.log("form data")
        // console.log(form_data)
        // return
        if (editClass) {
            console.log(`Edit class : ${editClass.platformID}`)
            console.log(new_time_objects.length);
            if (new_time_objects.length !== 1) {
                window.alert("Error updating class")
                return
            }

            // Need to fill form_data.service with existing class data. This catches zoom object
            form_data = {
                ...form_data,
                service: {
                    ...editClass,
                    ...form_data.service
                }
            }

            dispatch(updateExistingClass(editClass.platformID, form_data, new_time_objects[0]))
                .then(val => {
                    if (val.success && props.onHide) {
                        props.onHide()
                    } else if (val.message) {
                        window.alert(val.message)
                    }
                    console.log(`Did we Update it succesfully?: ${val.success}`)
                })
            return

        } else if (editService) {
            console.log("Edit service ", form_data)
            // return
            dispatch(updateExistingService(form_data))
                .then(val => {
                    if (val.success) {
                        props.onHide()
                    } else if (val.message) {
                        window.alert(val.message)
                    }
                    console.log(`Did we save it succesfully?: ${val.success}`)
                });
            return;
        } else if (newService) {
            // console.log("new service ", form_data)
            // return
            dispatch(uploadNewService(form_data))
                .then(val => {
                    if (val.success) {
                        props.onHide()
                    } else if (val.message) {
                        window.alert(val.message)
                    }
                    console.log(`Did we save it succesfully?: ${val.success}`)
                });
            return;
        } else if (newClass) {
            console.log("new class")
            console.log(new_time_objects.length);
            if (form_data.existing_service_type === CREATE_NEW) {
                // save service images
                // save new service
                //   - get service_id
                // save events with service_id & images
                
                
                console.log("saving new service...")
                dispatch(uploadNewServiceWithClasses(form_data, new_time_objects))
                    .then(val => {
                        if (val.success) {
                            props.onHide()
                        } else if (val.message) {
                            window.alert(val.message)
                        }
                        console.log(`Did we save it succesfully?: ${val.success}`)
                    });
            } else {
                console.log("saving existing service...")
                dispatch(uploadNewClasses(form_data, new_time_objects))
                    .then(val => {
                        if (val.success) {
                            props.onHide()
                        } else if (val.message) {
                            window.alert(val.message)
                        }
                        console.log(`Did we save it succesfully?: ${val.success}`)
                    });
            }

        }
    }

    const [contentLocation, setContentLocation] = React.useState(existingServiceObject?.location_name ?? "")
    const handleSetContentLocation = (location) => {
        setContentLocation(location)
        // if (location.toLowerCase().replace(/\s/g, '') === 'inperson') {
        //     setValue('service.location_type')
        // }
    }

    const [images, setImages] = React.useState(existingServiceObject?.images)
    //React.useState((existingServiceObject?.images && existingServiceObject.images.length && existingServiceObject.images.length > 0) ? existingServiceObject.images[0] : null)
    const {meet_time,start_date,end_date,days_of_the_week,start_time,duration} = watch(); // start_date
    const watchAll = watch()
    // var purchase_type = getValues('service.purchase_type')//.purchase_type // doign this so we can refresh teh form on free, dontation paid selection
    // if (getValues().purchase_type) {
    //     purchase_type = service.purchase_type
    // }
    function handleServiceSelection(e) {
        setOpenForm(true)
        setContentLocation(e.location_name || "")
        
        if (e === CREATE_NEW) {
            return
        }
        // setValue('service.platformID', val.platformID || "")
        // setValue('service.name', val.name || "")
        // setValue('service.experience_type', val.experience_type || "")
        // setValue('service.description', val.description || "")
        // setValue('service.workout_types', val.workout_types || [])
        // setValue('service.body_focus', val.body_focus || "")
        // setValue('service.intensity', val.intensity || "")
        // setValue('service.equipment_required', val.equipment_required || [])
        // setValue('service.max_capacity', val.max_capacity || 999)
        // setValue('service.purchase_type', val.purchase_type || 'Free')
        // setValue('service.price', val.price || 0)
        // setValue('service.minimum_price', val.minimum_price || 0)
        // setValue('service.location_type', val.location_type || 'live')
        // setValue('service.images', val.images || [])
        // setValue('service.platformID', val.platformID || "")
        // setValue('service.location_name', val.location_name || "")
        // setValue('service.instagram_handle', val.instagram_handle || "")
        // setValue('service.zoom_link', val.zoom_link || "")
        // setValue('service.youtube_link', val.youtube_link || "")
        // setValue('service.other_link', val.other_link || "")

        
        setTimeout(() => {
            setShowAdvanced(true)
            setImages(e.images)
            console.log("Settings service images: ", e.images)
            setValue([
                {"service.platformID":  e.platformID || ""},
                {"service.name":  e.name || ""},
                {"service.experience_type":  e.experience_type || ""},
                {"service.description":  e.description || ""},
                {"service.workout_types":  e.workout_types || []},
                {"service.body_focus":  e.body_focus || ""},
                {"service.intensity":  e.intensity || ""},
                {"service.equipment_required":  e.equipment_required || []},
                {"service.max_capacity":  e.max_capacity || 999},
                {"service.purchase_type":  e.purchase_type || 'Paid'},
                {"service.price":  e.price || 10},
                {"service.minimum_price":  e.minimum_price || 5},
                {"service.location_type":  e.location_type},
                {"service.images":  e.images || []},
                {"service.platformID":  e.platformID || ""},
                {"service.location_name":  e.location_name || ""},
                {"service.location": e.location || {}},
                {"service.instagram_handle":  e.instagram_handle || ""},
                {"service.zoom_link":  e.zoom_link || ""},
                {"service.youtube_link":  e.youtube_link || ""},
                {"service.other_link":  e.other_link || ""},
                // {"service.file1": (e.images && e.images.length > 0) ? e.images[0] : null}
                ])
            
        }, 500);

        
        
        // if (e.experience_type) {
        //     setFieldValue('service.experience_type', e.experience_type || "")
        // }
        

        
        // triggerValidation()
        // setFormOpen(true)
    }

    return (
    <>
    <form className={"classEditorForm pb-5" } onSubmit={handleSubmit(onSubmit)} noValidate={true}>
        <h2 className="font-weight-bold my-3">{formTitle}</h2>
        {newClass && (
        <div className="form-group">
            <label>Use an existing template?</label>
            <div className={"d-flex d-row"}>
                <Controller 
                as={CustomReactSelect}
                control={control}
                className="w-50"
                name="existing_service_type"
                setValue={setValue}
                getValues={getValues}
                options={existingServices.concat({value: CREATE_NEW, label: CREATE_NEW})}
                newSelection={(val) => {
                    // console.log(`selected service:`)
                    // console.log(val)
                    handleServiceSelection(val)
                }}
                />
                <button 
                type="button"
                onClick={() => {
                    router.push("/dashboard/home/templates")
                }} 
                className="btn btn-primary mx-3">
                    Add New
                </button> 
            </div>
        </div>
        )}
        {openForm && (<> {/* START openForm */}
        <div className="form-group">
            <label>What type of experience will this be?</label>
            <Controller 
            as={CustomReactSelect}
            control={control}
            className="w-50"
            name="service.experience_type"
            setValue={setValue}
            getValues={getValues}
            options={experienceTypes}
            />
            {/* <Controller
                className="w-50"
                as={<Select/>}
                options={experienceTypes}
                control={control}
                onChange={([selected]) => {
                    // handleServiceSelection(selected)
                    return selected
                }}
                name={"service.experience_type"}
            /> */}
        </div>

        <hr></hr>

        {/* <input className="form-control" type="time" placeholder="time" name="time" ref={register} /> */}
        <h3>What is this about?</h3>
        {/* <section className={ (editService || newService ? " d-none" : "")}></section> */}
        <div className={"p-0 col-lg-6 form-group" + (editService || newService ? " d-none" : "")}>
            <label>Who's teaching?</label>
            <Controller 
            as={CustomReactSelect}
            isMulti={true}
            maxOptions={2}
            control={control}
            className="w-100"
            name="hosted_by"
            placeholder="Select one.."
            setValue={setValue}
            getValues={getValues}
            options={connectedAccountOptions}
            newSelection={(hostIds) => {
                // if (hostIds.length > 2) {
                //     setValue('hosted_by', hostIds.slice(0,2))
                //     window.alert("Only 2 can teach at a time")
                //     return
                // }
                
                console.log("selected hosted_by: ", hostIds)
                // const theConnected = connectedAccounts.find(acct => acct.id === hostIds)

                const hostDataArray = hostIds.map(hostId => {
                    var connectedHost = connectedAccounts.find(acct => acct.id === hostId)
                    return connectedHost
                })
                // setValue('hostData', theConnected)
                // setHostData(theConnected)
                console.log(hostDataArray)
                setHostData(hostDataArray)
            }}
            />
            {errors?.hosted_by && (
                <div style={invalidStyle}>
                    {errors.hosted_by.message}
                </div>
            )}
        </div>
        <div className="form-group">
            <label>Name</label>
            <input ref={register} type={"text"} placeholder={"Name of experience"} name={"service.name"} className={"form-control" + (errors["service.name"] ? " custom-invalid" : "")} />
            {errors?.service?.name && (
                <div style={invalidStyle}>
                    {errors.service.name.message}
                </div>
            )}
        </div>

        <div className="form-group">
            <label>Description</label>
            <textarea ref={register} rows="8" type="textarea" placeholder={"Tell your fans about this experience"} name={"service.description"} className="form-control" />
            {errors?.service?.description && (
                <div style={invalidStyle}>
                    {errors.service.description.message}
                </div>
            )}
        </div>
        
        <div className="form-group">

            <Controller 
            as={ImageUpload}
            control={control}
            name="service.file1"
            // imageUrl={() => {
            //     function getTheValue(){
            //         const values = getValues("service.images")
            //         console.log("image vlaues: ", values)
            //         if (values && values.length > 0) {
            //             return values[0]
            //         }
            //         return null
            //     }
            //     return getTheValue()
            // }}
            imageUrl={(images && images.length && images.length > 0) ? images[0] : null}
            fileSelection={(file) => {
                // console.log("handle file selection")
                console.log(file)
                setValue('service.file1', file)
            }}
            />

            {/* <Controller 
            as={ImageAndUpload}
            name="service.images"
            control={control}
            square
            imageUrl={() => {
                const values = getValues("service.images")
                if (values && values.length > 0) {
                    return values[0]
                }
                return null
            }}
            onChange={(imageUrls) => {
                console.log("got new image url: ", imageUrls)
                console.log("imageurl length: ", imageUrls.length)
                setValue("service.images", [...imageUrls], {
                    shouldValidate: true,
                    shouldDirty: true
                  })
            }}
            /> */}

            {/* <ImageAndUpload
            square
            imageUrl={(images && images.length && images.length > 0) ? images[0] : null}
            name="service.images"
            filePath={`users/${currentUser.platformID}/images/`}
            onChange={(imageUrl) => {
                setValue('service.image1', imageUrl)
            }}
            /> */}

            
            {/* <ImageUpload
            imageUrl={(images && images.length && images.length > 0) ? images[0] : null}
            fileSelection={(file) => {
                // console.log("handle file selection")
                console.log(file)
                setValue('service.file1', file)
            }}
            /> */}
        </div>

        {showAdvanced ? (

        <div id="advanced">
            <div className="row">
                <div className="col-sm-6 form-group">
                    <label>Type of workout(s)</label>
                    <Controller 
                    as={CustomReactSelect}
                    control={control}
                    className="w-100"
                    name="service.workout_types"
                    setValue={setValue}
                    getValues={getValues}
                    options={workoutOptions}
                    isMulti={true}
                    />
                    {/* <Controller
                        className="w-100"
                        as={<Select isMulti={true}/>}
                        options={workoutOptions}
                        control={control}
                        onChange={([selected]) => {
                            // handleServiceSelection(selected)
                            return selected
                        }}
                        name={"service.workout_types"}
                    /> */}
                </div>
                <div className="col-sm-6 form-group">
                    <label>Area of focus</label>
                    <Controller 
                    as={CustomReactSelect}
                    control={control}
                    className="w-100"
                    name="service.body_focus"
                    setValue={setValue}
                    getValues={getValues}
                    options={bodyOptions}
                    />
                    {/* <Controller
                        className="w-100"
                        as={<Select />}
                        options={bodyOptions}
                        control={control}
                        onChange={([selected]) => {
                            // handleServiceSelection(selected)
                            return selected
                        }}
                        name={"service.body_focus"}
                    /> */}
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6 form-group">
                    <label>Intensity</label>
                    <Controller 
                    as={CustomReactSelect}
                    control={control}
                    className="w-100"
                    name="service.intensity"
                    setValue={setValue}
                    getValues={getValues}
                    options={intensityOptions}
                    />
                    {/* <Controller
                        className="w-100"
                        as={<Select/>}
                        options={intensityOptions}
                        control={control}
                        onChange={([selected]) => {
                            // handleServiceSelection(selected)
                            return selected
                        }}
                        name={"service.intensity"}
                    /> */}
                </div>
                <div className="col-sm-6 form-group">
                    <label>Suggested equipment</label>
                    <Controller 
                    as={CustomReactSelect}
                    control={control}
                    className="w-100"
                    name="service.equipment_required"
                    placeholder="Select if needed"
                    setValue={setValue}
                    getValues={getValues}
                    options={equipmentOptions}
                    isMulti={true}
                    />
                    {/* <Controller
                        className="w-100"
                        as={<Select placeholder="Select if needed..." />}
                        options={equipmentOptions}
                        control={control}
                        onChange={([selected]) => {
                            // handleServiceSelection(selected)
                            return selected
                        }}
                        name={"service.equipment_required"}
                    /> */}
                </div>
            </div>

        </div>

        ) : (
            <button className="btn btn-link" onClick={() => setShowAdvanced(true)}>Show advanced settings</button>
        )}
        <hr></hr>

        <section className={ (editService || newService ? " d-none" : "")}>
            <h3>Location</h3>
            <div className={"row"}>
                <div className="col-sm-6 form-group">
                    <label>Where is this hosted?</label>
                    <Controller 
                    as={CustomReactSelect}
                    control={control}
                    className="w-100"
                    name="service.location_name"
                    placeholder="Select one.."
                    setValue={setValue}
                    getValues={getValues}
                    options={hostingOptions}
                    newSelection={(val) => {
                        handleSetContentLocation(val)
                    }}
                    />
                    {errors?.service?.location_name && (
                        <div style={invalidStyle}>
                            {errors.service.location_name.message}
                        </div>
                    )}
                </div>
                <div className="col-sm-6 form-group">
                    {(() => {
                    // switch (getValues()["service.location_name"]?.value) {
                    switch (contentLocation?.toLowerCase()) {
                        case "in person":
                            return (
                                <Controller 
                                as={PlacesSearch}
                                control={control}
                                className="w-50"
                                name="service.location"
                                setValue={setValue}
                                getValues={getValues}
                                // options={existingServices.concat({value: CREATE_NEW, label: CREATE_NEW})}
                                onChange={(val) => {
                                    console.log(`selected place:`)
                                    console.log(val[0])
                                    // setValue('service.location', val[0])
                                    // handleServiceSelection(val)
                                    
                                }}
                                />
                                // <PlacesSearch />
                            )
                        case "instagram":
                            return (
                                <div>
                                    <label>Instagram handle</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">@</div>
                                        </div>
                                        <input ref={register} type={"text"} placeholder={"appstura"} name={"service.instagram_handle"} className={"form-control" + (errors?.service?.instagram_handle ? " custom-invalid" : "")} />
                                    </div>
                                </div>
                            )
                        case "zoom": // JARCH
                            return (
                                <>
                                { zoomConnected ? (
                                    <div>
                                        <label className="font-weight-bold">Your account is connected with Zoom</label>
                                        <p>When you schedule a class we will automatically schedule a Zoom meeting. You can find the meeting link on the homepage</p>
                                    </div>
                                ) : (
                                    <div>
                                        <label>Zoom meeting link&nbsp;</label>
                                        <NavLink to="/dashboard/settings#integrations">Connect your Zoom account</NavLink>
                                        <div className="input-group">
                                            <input ref={register} type={"text"} placeholder={"zoom.us/j/94036885861?pwd=ZVJGN0xB..."} name={"service.zoom_link"} className={"form-control" + (errors?.service?.zoom_link ? " custom-invalid" : "")} />
                                        </div>
                                    </div>
                                )}
                                </>
                            )
                        case "youtube":
                            return (
                                <div>
                                    <label>Profile URL</label>
                                    <div className="input-group">
                                        {/* <div className="input-group-prepend">
                                            <div className="input-group-text">@</div>
                                        </div> */}
                                        <input ref={register} type={"text"} placeholder={"youtube.com/user/sutra/live"} name={"service.youtube_link"} className={"form-control" + (errors?.service?.youtube_link ? " custom-invalid" : "")} />
                                    </div>
                                </div>
                            )
                        case "other":
                            return (
                                <div>
                                    <label>Website link</label>
                                    <div className="input-group">
                                        {/* <div className="input-group-prepend">
                                            <div className="input-group-text">@</div>
                                        </div> */}
                                        <input ref={register} type={"text"} placeholder={"zoom.us/j/94036885861?pwd=ZVJGN0xB..."} name={"service.other_link"} className={"form-control" + (errors?.service?.other_link ? " custom-invalid" : "")} />
                                    </div>
                                </div>
                            )
                        default:
                            return (<></>)
                    }
                    })()}
                        
                </div>
            </div>

            <hr></hr>

        </section>

        <section className={ (editService || newService ? " d-none" : "")}>
            <h3>When is this happening?</h3>
            {newClass && (
            <div className="row">
                <div className="col-sm-6 form-group">
                    <label>How often does this happen</label>
                    <Controller
                    as={CustomReactSelect}
                    control={control}
                    className="w-100"
                    name="meet_time"
                    setValue={setValue}
                    getValues={getValues}
                    options={meetTimeOptions}
                    />
                </div>
                {meet_time === "Weekly" && (
                    <div className="col-sm-6 form-group">
                        <label>Days of the week</label>
                        <Controller 
                        as={CustomReactSelect}
                        control={control}
                        className="w-100"
                        name="days_of_the_week"
                        setValue={setValue}
                        getValues={getValues}
                        options={weekdayOptions}
                        isMulti={true}
                        />
                    </div>
                )}
            </div>
            )}
            <div className="row">
                <div className="col-sm-6 form-group">
                    <label>Start date</label>
                    <Controller
                        className="form-control w-100"
                        as={<DatePicker
                        selected={moment(start_date, DATE_FORMAT).toDate()}
                        />}
                        // as={<DatePicker value={moment(getValues('start_date'), DATE_FORMAT)}/>}
                        control={control}
                        placeholderText="Select date"
                        onChange={([selected]) => {
                            // setValue('days_of_the_week', [{value:moment(selected).format('dddd'), label:moment(selected).format('dddd')}])
                            setValue('days_of_the_week', [moment(selected).format('dddd')])
                            return moment(selected).format(DATE_FORMAT)
                        }}
                        name={"start_date"}
                    />
                </div>
                {meet_time === "Weekly" && (
                    <div className="col-sm-6 form-group">
                        <label>End date</label>
                        <Controller
                            className="form-control w-100"
                            as={<DatePicker
                            selected={moment(end_date, DATE_FORMAT).toDate()}
                            />}
                            // as={<DatePicker value={moment(getValues('end_date'), DATE_FORMAT)}/>}
                            control={control}
                            placeholderText="Select date"
                            onChange={([selected]) => {
                                return moment(selected).format(DATE_FORMAT)
                            }}
                            name={"end_date"}
                        />
                    </div>
                )}
            </div>
            <div className="row">
                <div className="col-sm-6 form-group">
                    <label>Start time</label>
                    <Controller
                        className="form-control w-100"
                        as={<DatePicker
                            selected={moment(start_time, TIME_FORMAT).toDate()}
                            showTimeSelectOnly
                            showTimeSelect
                            timeIntervals={5}
                            dateFormat={TIME_FORMAT}
                        />}
                        control={control}
                        placeholderText="Select start"
                        onChange={([selected]) => {
                            // setValue('days_of_the_week', [{value:moment(selected).format('dddd'), label:moment(selected).format('dddd')}])
                            // setValue('days_of_the_week', [moment(selected).format('dddd')])
                            return moment(selected).format(TIME_FORMAT)
                        }}
                        name={"start_time"}
                    />
                </div>
                <div className="col-sm-6 form-group">
                    <label>Duration (minutes)</label> 
                    <div className="input-group">
                        {/* <div className="input-group-prepend">
                            <div className="input-group-text">$</div>
                        </div> */}
                        <input ref={register} type={"number"} placeholder={"Enter duration"} name={"duration"} className={"form-control" + (errors["duration"] ? " custom-invalid" : "")} />
                    </div>
                    {/* // JARCH */}
                    {/* <Controller
                        className="form-control w-100"
                        as={<DatePicker
                            selected={moment(end_time, TIME_FORMAT).toDate()}
                            showTimeSelectOnly
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat={TIME_FORMAT}
                        />}
                        control={control}
                        placeholderText="Select end"
                        onChange={([selected]) => {
                            return moment(selected).format(TIME_FORMAT)
                        }}
                        name={"end_time"}
                    /> */}
                </div>
                
                {/* meet_time: yup.string(), //Weekly || Specific Date
                start_date: yup.string().required(),
                end_date: yup.string(),
                days_of_the_week: yup.array().of(yup.string()).min(1),
                start_time: yup.string().required(),
                end_time: yup.string(), */}



            </div>
            <div>
                <ul>
                {/* {meet_time,start_date,end_date,days_of_the_week,start_time,end_time} */}
                    { buildModelsFrom({meet_time,start_date,end_date,days_of_the_week,start_time,duration}, timezone).map(val => {
                            return (<li key={val.desc}>{val.desc}</li>)
                    })}
                </ul>

            </div>
        </section>

        {/* START challengeid */}
        {!challengeid && (<>
        
        
        <hr></hr>
        <h3>Payment details</h3>
        <div className="row">
            <div className="col-sm-6 input-group">
                <label>How will people pay?</label>
                <Controller 
                as={CustomReactSelect}
                control={control}
                className="w-100"
                name="service.purchase_type"
                setValue={setValue}
                getValues={getValues}
                options={purchaseTypeOptions}
                // isMulti={true}
                />
                {/* // <Controller
                //     className="w-100"
                //     as={<Select/>}
                //     options={purchaseTypeOptions}
                //     control={control}
                //     onChange={([selected]) => {
                //         return selected
                //     }}
                //     name={"service.purchase_type"}
                // /> */}
            </div>
            {(() => {
            switch (getValues("service.purchase_type")) { // ["service.purchase_type"]?.value)
            
            case "Free":
                return (<></>)
            case "Donation":
                return (
                    <>
                        <div className="col-sm-3">
                            <label>Suggested price</label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">{currencySymbol}</div>
                                </div>
                                <input ref={register} type={"number"} placeholder={"Enter suggested price"} name={"service.price"} className={"form-control" + (errors["service.price"] ? " custom-invalid" : "")} />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <label>Minimum price</label>
                            <div className="input-group">
                                
                                <div className="input-group-prepend">
                                    <div className="input-group-text">{currencySymbol}</div>
                                </div>
                                <input ref={register} type={"number"} placeholder={"Enter miniumum price"} name={"service.minimum_price"} className={"form-control" + (errors["service.minimum_price"] ? " custom-invalid" : "")} />
                            </div>
                        </div>

                    </>
                    
                    
                )
            case "Paid":
                return (
                    <div className="col-sm-3">
                        <label>Required price</label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <div className="input-group-text">{currencySymbol}</div>
                            </div>
                            <input ref={register} type={"number"} placeholder={"Enter price"} name={"service.price"} className={"form-control" + (errors["service.price"] ? " custom-invalid" : "")} />
                        </div>
                    </div>
                )
            default:
                return (<></>)
            }
            })()}

        </div>

        <div className="row">
            <div className="col-sm-6 form-group">
                <label>Max capacity</label>
                <input ref={register} type={"number"} placeholder={"How many can attend?"} name={"service.max_capacity"} className={"form-control" + (errors["service.max_capacity"] ? " custom-invalid" : "")} />
                {errors?.service?.max_capacity && (
                    <div style={invalidStyle}>
                        {errors.service.max_capacity.message}
                    </div>
                )}
            </div>
        </div>

        </>)}{/* END CHallengeid */}
        

        
        

        <hr></hr>


        <>
        {/* {getValues() && ( */}
        {false && (
            <pre className="w-100" style={{
                "whiteSpace": "preWrap",       /* Since CSS 2.1 */
                "whiteSpace": "-moz-pre-wrap",  /* Mozilla, since 1999 */
                "whiteSpace": "-pre-wrap",      /* Opera 4-6 */
                "whiteSpace": "-o-pre-wrap",    /* Opera 7 */
                "wordSrap": "breakWord",
            }}>
                
                {JSON.stringify(getValues())}
                
                
            </pre>
        )}
        </>

        <>
        {/* {errors && ( */}
        {false && (
            <pre className="w-100" style={{
                "whiteSpace": "preWrap",       /* Since CSS 2.1 */
                "whiteSpace": "-moz-pre-wrap",  /* Mozilla, since 1999 */
                "whiteSpace": "-pre-wrap",      /* Opera 4-6 */
                "whiteSpace": "-o-pre-wrap",    /* Opera 7 */
                "wordSrap": "breakWord",
            }}>
                
                {JSON.stringify(errors)}
                
                
            </pre>
        )}
        </>

        <button
          variant="primary"
          disabled={!formState.dirty || isLoading} 
          type="submit" 
          className="btn btn-primary"
        >
          <span>Save</span>

          {isLoading && (
            <Spinner
              animation="border"
              size="sm"
              role="status"
              aria-hidden={true}
              className="ml-2"
            >
              <span className="sr-only">Sending...</span>
            </Spinner>
          )}
        </button>
        {/* <button disabled={!formState.dirty || isLoading} type="submit" className="btn btn-primary">Save</button> */}
        </>)}
        {/* END openForm */}

    </form>
    <DevTool control={control} />
    </>
    );
}

export default ClassEditor

const invalidStyle = {width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff4136"}

export const workoutOptions = [
    { value: 'Barre', label: 'Barre'},
    { value: 'Breathwork', label: 'Breathwork'},
    { value: 'Bootcamp', label: 'Bootcamp'},
    { value: 'Box', label: 'Box'},
    { value: 'Cardio', label: 'Cardio'},
    { value: 'Cycle', label: 'Cycle'},
    { value: 'Dance', label: 'Dance'},
    { value: 'HIIT', label: 'HIIT'},
    { value: 'Martial Arts', label: 'Martial Arts'},
    { value: 'Meditation', label: 'Meditation'},
    { value: 'Pilates', label: 'Pilates'},
    { value: 'Pre/Post Natal', label: 'Pre/Post Natal'},
    { value: 'Rowing', label: 'Rowing'},
    { value: 'Running', label: 'Running'},
    { value: 'Sculpt', label: 'Sculpt'},
    { value: 'Strength', label: 'Strength'},
    { value: 'Stretching', label: 'Stretching'},
    { value: "Suspension Training", label: "Suspension Training"},
    { value: 'Yoga', label: 'Yoga'},
    { value: 'Yoga Sculpt', label: 'Yoga Sculpt'},
    { value: "Vibration Training", label: "Vibration Training"},
    { value: 'Other', label: 'Other'}
]
export const bodyOptions = [
    {value: 'Total Body', label: 'Total Body'},
    {value: 'Upper Body', label: 'Upper Body'},
    {value: 'Lower Body', label: 'Lower Body'},
    {value: 'Core', label: 'Core'}
]
export const intensityOptions = [
    { value: "All Levels", label: "All Levels" }, 
    { value: "Beginner", label: "Beginner" }, 
    { value: "Intermediate", label: "Intermediate" }, 
    { value: "Advanced", label: "Advanced" }
]
export const equipmentOptions = [
    { value: "No Equipment", label: "No Equipment"},
    { value: "Ankle Weights", label: "Ankle Weights"},
    
    
    { value: "Any Weights", label: "Any Weights"},
    { value: "Light Weights", label: "Light Weights"},
    { value: "Medium Weights", label: "Medium Weights"},
    { value: "Heavy Weights", label: "Heavy Weights"},
    { value: "Resistance Bands", label: "Resistance Bands"},     
    { value: "Sliders", label: "Sliders"},
    { value: "Ball", label: "Pilates Ball"},
    { value: "Pilates Ring", label: "Pilates Ring"},
    { value: "Kettlebells", label: "Kettlebells"},
    { value: "Medicine Ball", label: "Medicine Ball"},
    { value: "Suspension Straps", label: "Suspension Straps"},
    { value: "Myofascial Balls", label: "Myofascial Balls"},
    { value: "Chair", label: "Chair"},
    { value: "Trampoline", label: "Trampoline"},
    
    { value: "Foam Roller", label: "Foam Roller"},
    { value: "Yoga Blanket", label: "Yoga Blanket"},
    { value: "Yoga Strap", label: "Yoga Strap"},
    { value: "Yoga Bolster ", label: "Yoga Bolster "},
    { value: "Yoga Mat", label: "Yoga Mat"},
    { value: "Yoga Block", label: "Yoga Block"},
]
const meetTimeOptions = [
    { value: "Specific Date", label: "Specific Date" },
    { value: "Weekly", label: "Weekly"}
]
const weekdayOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" }
]

const hostingOptions = [
    { value: "In person", label: "In person" },
    { value: "Zoom", label: "Zoom" },
    { value: "Instagram", label: "Instagram" },
    { value: "Youtube", label: "Youtube" },
    { value: "Other", label: "Other" }
]

const experienceTypes = [
    "Class",
    "Event", 
    "Workshop"
].map(val => { return {value: val, label: val.charAt(0).toUpperCase() + val.slice(1)}})
.concat({label: "Private", value: "Appointment"})

function buildModelsFrom(values, timezone) {

    var { meet_time, 
        start_date, 
        end_date, 
        days_of_the_week, 
        start_time, 
        // end_time,
        duration
    } = values;
    var new_time_objects = [];
    // meet_time = meet_time?.value
    // console.log('days of the week')
    // // console.log(days_of_the_week.length)
    // console.log(JSON.stringify(days_of_the_week))
    // return [];
    // days_of_the_week = days_of_the_week?.map(val => val?.value)
    if (meet_time === "Weekly") {

        const start_date_time = start_date + " " + start_time;
        const moment_start = moment(start_date_time)
        // console.log(`START: ${start_date_time}`)

        // const end_date_time = start_date + " " + end_time;
        // const moment_end = moment(end_date_time);

        // console.log(`END: ${end_date_time}`)

        // const duration = moment.duration(moment_end.diff(moment_start)).asMinutes(); // JARCH

        const end_of_series = moment(end_date).endOf('d');

        var moment_dates_for_classes = [];
        // console.log(days_of_the_week)
        (days_of_the_week ?? []).forEach(val => {
            var workingDate = moment_start.clone()
            console.log("start")
            console.log(workingDate.format('LLLL'))
            // find the first date...
            while (workingDate.format('dddd') !== val) {
                console.log('add day')
                workingDate = workingDate.add(1, 'd')
            }
            if (workingDate < end_of_series) {
                moment_dates_for_classes.push(workingDate.clone());
                // moment_dates_for_classes.push(JSON.parse(JSON.stringify(workingDate)));
                console.log(workingDate.format('LLLL'))
            }
            while (workingDate.clone().add(7, 'd') < end_of_series) {
                workingDate.add(7, 'd')
                moment_dates_for_classes.push(workingDate.clone())
            }
        })


        console.log(`This many dates: `, moment_dates_for_classes.length)
        new_time_objects = moment_dates_for_classes.map(start_date_time => {
            // console.log(start_date_time.format('LLLL'))

            const end_date_time = start_date_time.clone().add(duration, 'minutes');

            const time_string = start_date_time.format(DATE_FORMAT + " " + TIME_FORMAT) + " - " + end_date_time.format(TIME_FORMAT) + ` ${timezone}` + ` (${duration} min)`
            

            return {
                desc: time_string,
                start_time: start_date_time.unix(),
                // end_time: end_date_time.unix(),
                duration: duration
            }
        })



    } else {
        const start_date_time = start_date + " " + start_time;
        const moment_start = moment(start_date_time)
        // .format(DATE_FORMAT + " " + TIME_FORMAT);
        // const end_date_time = start_date + " " + end_time;
        const moment_end = moment_start.clone().add(duration, 'minutes')
        // moment(end_date_time);
        // .format(TIME_FORMAT);
        // const duration = moment.duration(moment_end.diff(moment_start)).asMinutes();

        const time_string = moment_start.format(DATE_FORMAT + " " + TIME_FORMAT) + " - " + moment_end.format(TIME_FORMAT) + ` ${timezone}` + ` (${duration} min)`
        
        new_time_objects.push({
            desc: time_string,
            start_time: moment_start.unix(),
            // end_time: moment_end.unix(),
            duration: duration
        })
    }

    // console.log(`Length of time objects: ${new_time_objects.length}`)

    // console.log(new_time_objects.length)
    // settime_objects(new_time_objects)
    return new_time_objects
}

const purchaseTypeOptions = ["Free", "Donation", "Paid"].map(val => {
    if (val === 'Donation') {
        return {value: val, label: "Sliding Scale"}
    }
    return {value: val, label: val}
})

const initialNewServiceValues = {
    experience_type: '',
    name: '',
    location_type: 'live',
    purchase_type: 'Paid',
    description: '',
    price: 10,
    minimum_price: 0,
    // duration: 0,
    workout_types: [],
    body_focus: '',
    intensity: '',
    equipment_required: [],
    max_capacity: 999,
    file1: null,
    file2: null,
    file3: null,
    images: [],
    preview_url: '',
    platformID: '',
    location_name: '',
    instagram_handle: '',
    zoom_link: '',
    youtube_link: '',
    other_link: ''
}